export const getNestedProperty = (key, object) =>{
  return key.split('.').reduce(function(o, key) {
    const value = Object.hasOwnProperty.call(o, key) ? o[key] : "";
    return value;
  }, object);
}